<template>
  <div class="page-container">
    <el-form
      :inline="true"
      class="demo-form-inline toolbar"
      style="padding-bottom: 0px"
    >
      <el-form-item>
        <kt-button
          type="warning"
          icon="el-icon-back"
          label="返回"
          @click="goBack()"
        />
      </el-form-item>
    </el-form>
    <div class="content">
      <el-form
        class="dataform"
        :model="dataForm"
        label-width="80px"
        :rules="dataFormRules"
        ref="dataForm"
        :size="size"
        label-position="right"
      >
        <el-row>
          <el-col :span="18">
            <el-row>
              <el-col :span="7">
                <el-form-item label="礼品编号" prop="giftNo">
                  <el-input
                    v-model="dataForm.giftNo"
                    auto-complete="off"
                    placeholder="礼品编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7" :offset="1">
                <el-form-item label="礼品名称" prop="giftName">
                  <el-input
                    v-model.trim="dataForm.giftName"
                    auto-complete="off"
                    placeholder="礼品名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7" :offset="1">
                <el-form-item label="礼品价格" prop="price">
                  <el-input
                    v-model="dataForm.price"
                    auto-complete="off"
                    placeholder="礼品价格"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="7">
                <el-form-item label="积分" prop="integral">
                  <el-input
                    v-model="dataForm.integral"
                    auto-complete="off"
                    placeholder="积分"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7" :offset="1">
                <el-form-item label="库存" prop="stock">
                  <el-input
                    v-model="dataForm.stock"
                    auto-complete="off"
                    placeholder="库存"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7" :offset="1">
                <el-form-item label="是否上架" prop="shelf">
                  <el-select
                    v-model="dataForm.shelf"
                    placeholder="是否上架"
                    @change="chengeShelf"
                  >
                    <el-option
                      v-for="item in whetherOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="7">
                <el-form-item label="开始时间" prop="periodStart">
                  <el-date-picker
                    :editable="editable"
                    :clearable="clearable"
                    style="width: 100%"
                    class="datepicker"
                    v-model="dataForm.periodStart"
                    type="datetime"
                    placeholder="开始时间"
                    :picker-options="pickerStartTime"
                    @change="changeStartTime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="7" :offset="1">
                <el-form-item label="结束时间" prop="periodEnd">
                  <el-date-picker
                    :editable="editable"
                    :clearable="clearable"
                    style="width: 100%"
                    class="datepicker"
                    v-model="dataForm.periodEnd"
                    type="datetime"
                    placeholder="结束时间"
                    :picker-options="pickerEndTime"
                    @change="changeEndTime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="7" :offset="1">
                <el-form-item label="是否发货" prop="send">
                  <el-select
                    v-model="dataForm.send"
                    placeholder="是否发货"
                    @change="changeSend"
                  >
                    <el-option
                      v-for="item in whetherOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-form-item label="" prop="giftPic" ref="giftPic">
              <div class="rz-picter">
                <span style="color: red">*</span>
                <img :src="avatar" alt="" class="img-avatar" />
                <input
                  type="file"
                  name="avatar"
                  id="uppic"
                  accept="image/gif,image/bmp,image/jpeg,image/jpg,image/png"
                  @change="changeImage($event)"
                  ref="avatarInput"
                  class="uppic"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="礼品描述" prop="remark" ref="remark">
              <div class="editor-container">
                <el-input
                  
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row> </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        align="center"
        style="padding-bottom: 20px"
      >
        <el-button
          :size="size"
          @click.native="reset"
          plain
          v-if="!this.giftPicId"
          >重置</el-button
        >
        <el-button
          :size="size"
          type="primary"
          plain
          @click.native="submitForm"
          :loading="editLoading"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  components: {
    KtButton,
  },
  data() {
    var validatePic = (rule, value, callback) => {
      if (this.filePic || this.avatar != require("@/assets/beadhouse/jia.png")) {
        callback();
      } else {
        callback(new Error("请上传图片"));
      }
    };
    return {
      editable: false,
      clearable: false,
      startTimestamp: "", //开始时间的时间戳
      endTimestamp: "", //结束时间的时间戳
      remarkLength: "", //富文本字符长度
      filePic: "", //图片文件
      giftPicId: "", //图片的id
      picture: "picture", //上传的文件格式
      bucketName: "cmny-oss", //七牛云bucket
      avatar: require("@/assets/beadhouse/jia.png"),
      size: "medium",
      defaultMsg: "",
      config: {
        autoHeightEnabled: false,
        autoFloatEnabled: true,
        initialContent: "请输入内容", //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
        autoClearinitialContent: true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
        initialFrameWidth: null,
        initialFrameHeight: 450,
        maximumWords: 600, //配置可输入最大字符
        BaseUrl: "",
        UEDITOR_HOME_URL: "static/ueditor/",
      },
      addFormVisible: false,
      whetherOptions: [],
      dataForm: {
        giftNo: "",
        giftName: "",
        price: "",
        giftPic: "",
        integral: "",
        stock: "",
        shelf: "",
        send: "",
        periodStart: "",
        periodEnd: "",
        remark: "",
      },
      editLoading: false,
      dataFormRules: {
        giftNo: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 15, message: "长度在1到15位的数字" },
          { pattern: /^[0-9]+$/, message: "请输入由数字组成的字符" },
        ],
        giftName: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 15, message: "长度在1到15位的字符" },
        ],
        price: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 3, message: "长度在1到3位的数字" },
          { pattern: /^[0-9]+$/, message: "请输入由数字组成的字符" },
        ],
        giftPic: [
          { required: true, validator: validatePic, trigger: "change" },
        ],
        integral: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 8, message: "长度在1到8位的数字" },
          { pattern: /^[0-9]+$/, message: "请输入由数字组成的字符" },
        ],
        stock: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 8, message: "长度在1到8位的数字" },
          { pattern: /^[0-9]+$/, message: "请输入由数字组成的字符" },
        ],
        shelf: [{ required: true, message: "不能为空", trigger: "change" }],
        send: [{ required: true, message: "不能为空", trigger: "change" }],
        periodStart: [{ required: true, message: "不能为空", trigger: "blur" }],
        periodEnd: [{ required: true, message: "不能为空", trigger: "blur" }],
        remark: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 600, message: "长度在1到600个字符" },
        ],
      },
      /*  开始时间大于等于今天,结束时间大于开始时间 */
      pickerStartTime: {
        disabledDate: (time) => {
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate() - 1));
          return time < nowData;
        },
      },
      pickerEndTime: {
        disabledDate: (time) => {
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate() - 1));
          return time < nowData;
        },
      },
    };
  },
  methods: {
    //清除校验
    clearValidate(formName) {
      //formName为传入要清除的prop ，可以是整个form表单，也可以是一个
      this.$refs[formName].clearValidate();
    },
    // 返回
    goBack() {
      console.log("返回上层");
      bus.$emit('close_current_tags');
    },
    //校验只能上传jpg和png格式的图片
    beforeUpload(file) {
      //图片上传之前校验
      console.log(file, "-----------------------进来了");
      if (file != undefined) {
        let isPNG = false;
        file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
        const isLt2048k = file.size / 1024 < 2048;
        if (!isPNG) {
          this.$message.error("上传图片格式不能是 gif 格式");
          return false;
        }
        if (!isLt2048k) {
          this.$message.error("上传图片大小不能超过 2Mb");
          return false;
        }
        console.log(isPNG, isLt2048k);
        return isPNG && isLt2048k;
      }
    },
    //上传图片
    changeImage(e) {
      console.log(e);
      this.filePic = e.target.files[0];
      if (this.filePic) {
        //判断图片文件是否存在
        this.clearValidate("giftPic"); // 清除gitPic的校验
      }
      var file = e.target.files[0];
      console.log(file);
      if (this.beforeUpload(file)) {
        var reader = new FileReader();
        var that = this;
        if (file != undefined) {
          reader.readAsDataURL(file);
          reader.onload = function () {
            console.log(this.result);
            that.avatar = this.result;
          };
          let params = new FormData();
          params.append("file", file);
          params.append("fileType", this.picture);
          params.append("bucketName", this.bucketName);
          console.log(params);
          this.$postFormData("opc/file/uploadFile", params).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.dataForm.giftPic = res.result;
            } else {
              this.$message({ message: res.message, type: "error" });
              this.dataForm.giftPic = "";
              this.filePic = ""; //清空上传的图片文件
              this.avatar = require("@/assets/beadhouse/jia.png"); //清空上传的图片显示
              document.getElementById("uppic").value = ""; //每次关闭dialog框都清空上传文件file的值，以防再次打开选择相同的不能触发change时间
            }
          });
        }
      } else {
        document.getElementById("uppic").value = ""; //每次关闭dialog框都清空上传文件file的值，以防再次打开选择相同的不能触发change时间
      }
    },
    //图片的回显
    getImgInfo() {
      let id = this.giftPicId;
      console.log(id);
      if (id) {
        this.$postForm("opc/file/queryAttachmentById/" + id).then((res) => {
          console.log(res);
          var path = res.result.path;
          var name = res.result.name;
          this.avatar = "http://51cs8.com/" + path + name; //拼接img的src路径,回显图片
        });
      }
    },
    //富文本编辑框获取数据
    getContent() {
      let content = this.$refs.ueditor.getUEContent();
      console.log(content);
      this.dataForm.remark = content;
      console.log("this.dataForm.remark的值为" + this.dataForm.remark);
    },
    //富文本编辑框回显数据
    setUEContent(val) {
      this.$refs.ueditor.setUEContent(val);
    },

    //监听富文本框数据的变化
    editorReady(editor) {
      editor.setContent(this.dataForm.remark);
      editor.addListener("contentChange", () => {
        this.dataForm.remark = editor.getContent();
        console.log(this.dataForm.remark);
        var remarkStr = this.dataForm.remark.replace(/<\/?.+?>/g, "");
        var remarkNewStr = remarkStr.replace(/ /g, ""); //remarkNewStr为得到后的内容
        let remarkLength = remarkNewStr.replace(/(\s|\&nbsp\;||\xc2\xa0)/g, ""); //清除空格 &nbsp;
        this.remarkLength = remarkLength;
        console.log(
          remarkNewStr,
          remarkNewStr.length,
          this.remarkLength,
          this.remarkLength.length
        );
        if (this.dataForm.remark && this.remarkLength.length <= 600) {
          this.clearValidate("remark"); // 清除remark的校验
        } else if (this.remarkLength.length > 600) {
          console.log("vbfnmbnfbn------");
          return this.$alert("最多只能600个字符", {
            confirmButtonText: "确定",
          });
        }
      });
    },
    //重置填写的内容
    reset() {
      this.dataForm = {};
      this.$refs.ueditor.setUEContent("", false); //清空富文本
      this.filePic = ""; //清空上传的图片文件
      this.avatar = require("@/assets/beadhouse/jia.png"); //清空上传的图片显示
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
    },
    //提交数据
    submitForm() {
      this.getContent();
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            if (
              this.remarkLength.length > 0 &&
              this.remarkLength.length <= 600
            ) {
              this.editLoading = true;
              let params = Object.assign({}, this.dataForm);
              console.log(this.giftPicId, params);
              // this.giftPicId是否存在,如果存在就是从修改跳转过来的，如果不存在就是从新增跳转过来的
              let url = "";
              if (this.giftPicId) {
                url = "omc/gift/edit";
                console.log(
                  "this.giftPicId存在------this.giftPicId的值为" +
                    this.giftPicId
                );
              } else {
                url = "omc/gift/add";
                console.log(
                  "this.giftPicId不存在********this.giftPicId的值为" +
                    this.giftPicId
                );
              }
              console.log(url);
              this.$postJson(url, params)
                .then((res) => {
                  console.log(res);
                  this.editLoading = false;
                  if (res.code == 200) {
                    this.$message({ message: "操作成功", type: "success" });
                    this.dialogVisible = false;
                    this.$refs["dataForm"].resetFields();
                  } else {
                    this.$message({
                      message: "操作失败, " + res.message,
                      type: "error",
                    });
                  }
                  this.$router.push({ path: "/volunteergiftslist" }); //编程式导航跳转  query传参
                })
                .catch((error) => {
                  this.editLoading = false;
                  this.$message({
                    message: "操作失败, " + error.message,
                    type: "error",
                  });
                });
            } else {
              this.$message({
                message: "操作失败,礼品描述最多只能输入600个字符",
                type: "error",
              });
            }
          });
        } else {
          this.$message({ message: "请检查红色必填项", type: "error" });
        }
      });
    },
    //选取开始时间
    changeStartTime(val) {
      console.log(val);
      this.dataForm.periodStart = util.formatDate.format(
        new Date(val),
        "yyyy-MM-dd hh:mm:ss"
      );
      console.log(this.dataForm.periodStart);
      this.startTimestamp = parseInt(
        new Date(this.dataForm.periodStart).getTime() / 1000
      ); // 当前时间戳
      this.endTimestamp = parseInt(
        new Date(this.dataForm.periodEnd).getTime() / 1000
      ); // 当前时间戳
      console.log(
        this.startTimestamp,
        this.endTimestamp,
        this.dataForm.periodEnd
      );
      if (this.dataForm.periodEnd) {
        if (this.endTimestamp <= this.startTimestamp) {
          this.$message({ message: "开始时间要小于结束时间", type: "error" });
          this.dataForm.periodStart = "";
        }
      }
    },
    //选择结束时间
    changeEndTime(val) {
      console.log(val);
      if (this.dataForm.periodStart) {
        this.dataForm.periodEnd = util.formatDate.format(
          new Date(val),
          "yyyy-MM-dd hh:mm:ss"
        );
        console.log(this.dataForm.periodEnd);
        this.endTimestamp = parseInt(
          new Date(this.dataForm.periodEnd).getTime() / 1000
        ); // 当前时间戳
        console.log(this.endTimestamp);
        if (this.endTimestamp <= this.startTimestamp) {
          this.$message({ message: "结束时间要大于开始时间", type: "error" });
          this.dataForm.periodEnd = "";
        }
      } else {
        this.$message({ message: "请先选择开始时间", type: "error" });
        this.dataForm.periodEnd = "";
      }
    },
    //选取是否上架
    chengeShelf(val) {
      console.log(val);
      this.dataForm.shelf = val;
    },
    //选取是否发货
    changeSend(val) {
      console.log(val);
      this.dataForm.send = val;
    },
    //初始化是否发货和是否上架
    initialwhethers() {
      var whethers = ["否", "是"];
      for (var i = 0; i < whethers.length; i++) {
        var item = {};
        item.value = i;
        item.label = whethers[i];
        this.whetherOptions.push(item);
      }
    },
  },
  created() {
    this.initialwhethers();
    if (this.$route.query.res) {
      //接收parmas传递的一个对象
      let data = JSON.parse(this.$route.query.res);
      data.shelf == "否" ? (data.shelf = 0) : (data.shelf = 1);
      data.integral = String(data.integral);
      data.price = String(data.price);
      data.stock = String(data.stock);
      console.log(data);
      this.dataForm = Object.assign({}, data);
      this.giftPicId = data.giftPic;
      console.log(this.giftPicId);
    }
  },
  mounted() {
    this.getImgInfo();
    console.log(this.dataForm.remark);
    this.setUEContent(this.dataForm.remark); //加载完成调取函数回显富文本框的数据
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  height: 500px;
  display: flex;
  flex-direction: column;
  background: #fff;
  .demo-form-inline {
    height: 60px;
  }
  .content {
    width: 100%;
    border: 1px solid #ccc;
    margin-bottom: 20px;
    background: #fff;
    .dataform {
      width: 98%;
      margin: 10px auto 5px auto;
    }
    .editor-container {
      width: 100%;
      height: 100%;
    }
  }
}
.rz-picter {
  width: 100%;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.rz-picter:hover {
  border-color: #409eff;
}
.img-avatar {
  width: 140px;
  height: 140px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.uppic {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  opacity: 0;
}
//修改ue富文本编辑框的层级问题
::deep .edui-editor {
  z-index: 1 !important;
}
</style>
